import { render, staticRenderFns } from "./SectionDefinition.vue?vue&type=template&id=1e047cb8&scoped=true&"
import script from "./SectionDefinition.vue?vue&type=script&lang=js&"
export * from "./SectionDefinition.vue?vue&type=script&lang=js&"
import style0 from "./SectionDefinition.vue?vue&type=style&index=0&id=1e047cb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e047cb8",
  null
  
)

component.options.__file = "SectionDefinition.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBreadcrumbs } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VBreadcrumbs,
  VBtn,
  VContainer,
  VIcon,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
